import React from "react";
import 'react-responsive-modal/styles.css';
import linkedinLogo from '../assets/linkedinLogo.png';


export default class ModalDownload extends React.Component {

  render() {
    const openLinkedIn = () => window.open('https://www.linkedin.com/in/marceloleitemt/');

    return (
      <div>
          <button className="btn-download" onClick={openLinkedIn}>
            <img src={linkedinLogo} alt="LinkedIn" style={{width: '50px', height: '50px', marginRight: '10px', verticalAlign: 'middle', borderRadius: '5px'}} />
            Marcelo Leite
          </button>
      </div>
    );
  }
}